import React, { useState } from 'react'
import roleApi from '../api/role/RoleApi'
import { toast } from 'sonner'
import SearchCompaniesModal2 from './SearchCompaniesModal2'
import { CompanyDto } from '../api/company/models/CompanyDto'

type Props = {
    roleId: string
    selectedCompanySeedIds: string[]
    onClose: (companiesChanged: boolean) => void
}

function AddCompanyLinkModal({
    roleId,
    selectedCompanySeedIds,
    onClose,
}: Props): React.JSX.Element {
    const [isModalLoading, setIsModalLoading] = useState<boolean>(false)

    async function handleCompanySelected(company: CompanyDto) {
        setIsModalLoading(true)

        try {
            await roleApi.addCompanyLinks({
                companyIds: [company.id],
                roleId: roleId,
            })

            onClose(true)
        } catch (error) {
            console.error(error)
            toast.error(
                `There was a problem adding the company link, please try again.`,
                {
                    duration: 5000,
                },
            )
        } finally {
            setIsModalLoading(false)
        }
    }

    return (
        <SearchCompaniesModal2
            onClose={() => onClose(false)}
            onSelect={handleCompanySelected}
            externalIsLoading={isModalLoading}
            selectedCompanySeedIds={selectedCompanySeedIds}
        />
    )
}

export default AddCompanyLinkModal
